// extracted by mini-css-extract-plugin
export default {"mediaCard":"dashboard_media_carousel__mediaCard--wSuf"};